import Block from '@mui/icons-material/Block'
import Email from '@mui/icons-material/Email'
import Lock from '@mui/icons-material/Lock'
import PhoneAndroid from '@mui/icons-material/PhoneAndroid'
import CloseIcon from '@mui/icons-material/Close'
import { Button, Dialog } from '@mui/material'
import { useContext } from 'react'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { logoutHandler } from 'src/consumer/services/loginLogoutHandlers'

export function WrongSigninModal({
  open = false,
  onClose,
  noCloseButton,
  openPageLink,
  rightAccountData,
  ...rest
}) {
  const { profileData } = useContext(ProfileContext)

  const clientUserLoginHint = rightAccountData?.clientUserLoginHint
  const supportWhatsappNumber = rightAccountData?.supportWhatsappNumber
  const isHintEmail = clientUserLoginHint?.includes('@')

  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      {...rest}
      PaperProps={{
        sx: { padding: '32px', maxWidth: 'none', borderRadius: '8px' },
      }}
    >
      {!Boolean(noCloseButton) && (
        <CloseIcon
          sx={{ position: 'absolute', top: '20px', right: '20px', cursor: 'pointer' }}
          onClick={onClose}
        />
      )}
      <div className="d-flex flex-column gap-2">
        <div style={{ fontSize: '18px', paddingBottom: '24px' }}>
          <b>Access Denied</b>
        </div>
        <div
          className="d-flex justify-content-center align-items-center gap-1"
          style={{ width: 'fit-content' }}
        >
          <Block style={{ color: 'red' }} />
          This video call link is intended for a specific user.
        </div>
        <div
          className="d-flex justify-content-center align-items-center gap-1"
          style={{ width: 'fit-content' }}
        >
          <Lock style={{ color: 'gold' }} />
          <b>This call is reserved for:</b>
        </div>
        <div
          className="d-flex justify-content-center align-items-center gap-1"
          style={{ width: 'fit-content' }}
        >
          {isHintEmail ? <Email /> : <PhoneAndroid />}
          <div>
            <b>{isHintEmail ? 'Email: ' : 'Phone: '}</b>
            <span style={{ background: '#e3e1e1', padding: '2px 6px' }}>{clientUserLoginHint}</span>
          </div>
        </div>
        <div style={{ width: 'fit-content', margin: '24px 0' }}>
          Please log in as the correct user to join this call. If you believe this is an error,
          please contact support.
        </div>
        <div className="d-flex flex-column align-items-center gap-2">
          <Button
            variant="contained"
            onClick={() => {
              logoutHandler()
              window.location.reload()
            }}
          >
            Log in as the correct user
          </Button>
          {supportWhatsappNumber && (
            <Button
              onClick={() => {
                const message = encodeURIComponent(
                  `Hello, I need help. I am trying to open ${openPageLink} and the application is not allowing me to open the page. I am logged in with ${profileData?.userName}.`,
                )
                window.open(`https://wa.me/${supportWhatsappNumber}?text=${message}`, '_blank')
              }}
            >
              Talk to support
            </Button>
          )}
        </div>
      </div>
    </Dialog>
  )
}
